import {
    ADD_FETCH_ALL_COUNT_ADMINS_FAILURE,
    ADD_FETCH_ALL_COUNT_ADMINS_REQUEST,
    ADD_FETCH_ALL_COUNT_ADMINS_SUCCESS,
    ADD_FETCH_ALL_COUNT_STAFF_FAILURE,
    ADD_FETCH_ALL_COUNT_STAFF_REQUEST,
    ADD_FETCH_ALL_COUNT_STAFF_SUCCESS,
    RESET_CURRENT_BLOCK,
    GET_PATIENT_COUNT_FAILURE,
    GET_PATIENT_COUNT_REQUEST,
    GET_PATIENT_COUNT_SUCCESS,
} from "./dashboardType";

export const fetchAdminCountRequest = () => ({
  type: ADD_FETCH_ALL_COUNT_ADMINS_REQUEST,
});

export const fetchAdminCountSuccess = (data) => ({
  type: ADD_FETCH_ALL_COUNT_ADMINS_SUCCESS,
  payload: { data },
});

export const fetchAdminCountFailure = (error) => ({
  type: ADD_FETCH_ALL_COUNT_ADMINS_FAILURE,
  payload: { error },
});

export const fetchStaffCountRequest = () => ({
  type: ADD_FETCH_ALL_COUNT_STAFF_REQUEST,
});

export const fetchStaffCountSuccess = (data) => ({
  type: ADD_FETCH_ALL_COUNT_STAFF_SUCCESS,
  payload: { data },
});

export const fetchStaffCountFailure = (error) => ({
  type: ADD_FETCH_ALL_COUNT_STAFF_FAILURE,
  payload: { error },
});

export const resetCurrentBlock = () => ({
  type: RESET_CURRENT_BLOCK
});

export const getPatientCountRequest = (number) => ({
  type: GET_PATIENT_COUNT_REQUEST,
  payload: { number },
});

export const getPatientCountSuccess = (data) => ({
  type: GET_PATIENT_COUNT_SUCCESS,
  payload: { data },
});

export const getPatientCountFailure = (error) => ({
  type: GET_PATIENT_COUNT_FAILURE,
  payload: { error },
});
  